import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref, shallowRef, watch } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import { JSONFieldType } from '@/components/business/crud/interface/FieldType';
import * as monaco from 'monaco-editor';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { monacoHolder } from '@/util/monaco';


import { definedWidgetMeta } from '@/components/business/crud/widgets/widgetManager';

export const meta = definedWidgetMeta({
  size: { edit: 'large', show: 'large' },
});

export default /*#__PURE__*/_defineComponent({
  __name: 'JsonForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();
const containerRef = ref<HTMLElement>();
const editRef = ref<HTMLElement>();
const viewRef = ref<HTMLElement>();
const editor = shallowRef<monaco.editor.IStandaloneCodeEditor>();
const viewer = shallowRef<monaco.editor.IStandaloneCodeEditor>();

onMounted(() => {
  if (editRef.value) {
    const resizeObserver = new ResizeObserver(() => {
      if (editor.value) {
        editor.value.layout();
      }
    });
    resizeObserver.observe(editRef.value);
  }
  if (viewRef.value) {
    const resizeObserver = new ResizeObserver(() => {
      if (viewer.value) {
        viewer.value.layout();
      }
    });
    resizeObserver.observe(viewRef.value);
  }
});

const value = computed({
  get: () => JSON.stringify(data.value[props.propName], null, 4),
  set: (value) => {
    try {
      const json = JSON.parse(value);
      if (json !== data.value[props.propName]) {
        data.value[props.propName] = json;
      }
    } catch (e) {
      // pass
    }
  },
});

watch([editRef], () => {
  if (editor.value) {
    editor.value.dispose();
  }
  if (editRef.value) {
    editor.value = monacoHolder.value.editor.create(editRef.value, {
      value: value.value,
      language: 'json',
      theme: 'vs-dark',
      minimap: {
        enabled: false,
      },
      readOnly: props.info.status === 'show',
    });
    editor.value.onDidChangeModelContent(function (event) {
      if (editor.value) {
        value.value = editor.value.getValue();
      }
    });
  }
});

watch(value, () => {
  const json = value.value;
  if (editor.value && editor.value.getValue() !== json) {
    editor.value.setValue(json);
  }
});

watch(
  () => props.info.status,
  (value) => {
    if (editor.value) {
      editor.value.updateOptions({
        readOnly: value === 'show',
      });
    }
  }
);

function format() {
  if (editor.value) {
    editor.value.getAction('editor.action.formatDocument')?.run();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "editor-container",
    style: {"padding":"0 16px"},
    ref_key: "containerRef",
    ref: containerRef
  }, [
    _withDirectives(_createVNode(ScBtn, {
      text: "格式化",
      handler: format,
      size: "small",
      style: {"margin-bottom":"8px"}
    }, null, 512), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _createElementVNode("div", {
      ref_key: "editRef",
      ref: editRef,
      style: {"width":"100%","height":"800px"}
    }, null, 512)
  ], 512))
}
}

})